var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "8 1.33266667 8 0 4 0 4 1.33266667 0 1.33266667 0 2.666 12 2.666 12 1.33266667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33333333,3.33266667 L1.33333333,11.3326667 C1.33333333,12.0673333 1.93133333,12.666 2.66666667,12.666 L9.33333333,12.666 C10.0686667,12.666 10.6666667,12.0673333 10.6666667,11.3326667 L10.6666667,3.33266667 L1.33333333,3.33266667 Z M5.33333333,10 L4,10 L4,6 L5.33333333,6 L5.33333333,10 Z M8,10 L6.66666667,10 L6.66666667,6 L8,6 L8,10 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9ee744345820cd315e7e74f53bbef3ed.svg";
export { ForwardRef as ReactComponent };